import React from "react";
import {Container} from "reactstrap";
const Header = () => (
    <Container fluid className="bg-secondary text-center text-white page-header fixed-header">
        <h2>Search On</h2>
    </Container>
)
export default Header